import { render } from "./SystemTabGeral.vue?vue&type=template&id=1583e813&scoped=true&ts=true"
import script from "./SystemTabGeral.vue?vue&type=script&lang=ts"
export * from "./SystemTabGeral.vue?vue&type=script&lang=ts"

import "./SystemTabGeral.vue?vue&type=style&index=0&id=1583e813&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1583e813"]])

export default __exports__